<template>
  <b-card :title="aviso.titulo">
    <b-card-text>
      <p v-html="aviso.descricao" />
    </b-card-text>
  </b-card>
</template>

<script>
export default {
  data() {
    return {
      aviso: null,
    }
  },
  created() {
    this.aviso = this.$store.getters['mural/getAviso'](
      Number(this.$route.params.id),
    )
  },
  methods: {},
}
</script>
